import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InsertCommentIcon from "@mui/icons-material/InsertComment";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import UndoIcon from "@mui/icons-material/Undo";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Lottie from "lottie-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import TinderCard from "react-tinder-card";
import shuffleArray from "shuffle-array";
import animationData from "../assets/lottieData3.json";
import soundAnimation from "../assets/soundGIF.json";
import CustomAnswerSheet from "../component/CustomAnswerSheet";
import { setFalse, setTrue } from "../features/bgm/BgmSlice";
import "./Advanced.css";
import ReactFurigana from 'react-furigana';
import { isSafari} from 'is-where'



function Advanced({ customHudaList, sdgsNum, play }) {
    const dispatcher = useDispatch();
    const navigate = useNavigate();
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    const [hasKanji,setHasKanji] = useState([false,false,false])
 
    const newHudaList = useRef(shuffleArray.pick(customHudaList, { picks: customHudaList.length }).filter((i) => i.sdgsNum == sdgsNum));
    // const newHudaList = useRef(shuffleArray.pick(customHudaList, { picks: customHudaList.length }));
    const [currentIndex, setCurrentIndex] = useState(newHudaList.current.length - 1);
    const [lastDirection, setLastDirection] = useState();
    const [open, setOpen] = useState(false);
    const [loadList, setLoadList] = useState([]);
    const [isTimeout, setIsTimeout] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const [isOpenBottomSheet, setOpenBottomSheet] = useState(false);
    const isHeight = useMediaQuery({ query: "(min-height: 620px)" });
    useEffect(() => {
        if (newHudaList.current.length != 1) {
            setOpen(true);
            let timer1 = setTimeout(() => setOpen(false), 3.9 * 1000);
            setIsTimeout(true);
            return () => {
                clearTimeout(timer1);
            };
        }
        
    }, []);
    useEffect(()=>{
        setHasKanji([false,false,false]);
    },[currentIndex])
    useEffect(() => {
        if (isTimeout && loadList.length == newHudaList.current.length) {
            setOpen(false);
        }
    }, [loadList]);
    
    // used for outOfFrame closure
    const currentIndexRef = useRef(currentIndex);

    const childRefs = useMemo(
        () =>
            Array(newHudaList.current.length)
                .fill(0)
                .map((i) => React.createRef()),
        []
    );

    const updateCurrentIndex = (val) => {
        setIsPlaying(false);
        setCurrentIndex(val);
        currentIndexRef.current = val;
    };

    const canGoBack = currentIndex < newHudaList.current.length - 1;

    const canSwipe = currentIndex >= 0;

    // set last direction and decrease current index
    const swiped = async (direction, index) => {
        if (index != 0) {
            setLastDirection(direction);
            updateCurrentIndex(index - 1);
        }
    };

    const outOfFrame = (idx) => {
       
        // handle the case in which go back is pressed before card goes outOfFrame
        try{
            currentIndexRef.current >= idx && childRefs[idx].current.restoreCard();
        }catch(e){
           
        }
        
        // TODO: when quickly swipe and restore multiple times the same card,
        // it happens multiple outOfFrame events are queued and the card disappear
        // during latest swipes. Only the last outOfFrame event should be considered valid
    };

    const swipe = async (dir) => {
        if (canSwipe && currentIndex < newHudaList.current.length) {
            await childRefs[currentIndex].current.swipe(dir); // Swipe the card!
        }
    };

    // increase current index and show card
    const goBack = async () => {
        // dispatcher(buttonEffectSetTrue());
        if (!canGoBack) return;
        const newIndex = currentIndex + 1;
        updateCurrentIndex(newIndex);
        await childRefs[newIndex].current.restoreCard();
    };
    const [isPlaying, setIsPlaying] = useState(false);
    const soundRef = useRef();
    function soundPlay() {
        setIsPlaying(true);
        dispatcher(setFalse());
        const playPromise = soundRef.current.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
        }
    }
    
    const setFurigana = (yomiString)=>{
       var yomiList =  yomiString.split("/");
       return(<div>
            <span style={{fontWeight:"500", display:"inline-block",marginTop:yomiList[0].includes("[")?"-10px":"0"} }>
            <ReactFurigana  text= {yomiList[0] }
             ></ReactFurigana> 
             </span>
             <br></br>
             <span style={{fontWeight:"500", display:"inline-block",marginTop:yomiList[1].includes("[")?"-10px":"0"}}>
             <ReactFurigana  text= {yomiList[1]}
            ></ReactFurigana> 
             </span>
            <br></br>
            <span style={{fontWeight:"500", display:"inline-block",marginTop:yomiList[2].includes("[")?"-10px":"0"}}>
             <ReactFurigana  text= {yomiList[2]}
            ></ReactFurigana> 
            </span>
        </div>)

    }
   
    return (
        <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div className="play-page">
                <link href="https://fonts.googleapis.com/css?family=Damion&display=swap" rel="stylesheet" />
                <link href="https://fonts.googleapis.com/css?family=Alatsi&display=swap" rel="stylesheet" />
                <audio
                    src={newHudaList.current[currentIndex].sound}
                    ref={soundRef}
                    onEnded={() => {
                        setIsPlaying(false);
                        dispatcher(setTrue());
                    }}
                ></audio>
                <div className= {isWide?"head-bar-wide":"head-bar"}>
                    <IconButton
                        onClick={() => {
                            play();
                            dispatcher(setTrue());
                            try{
                                navigate("/selectNum");
                            }catch(e){
                             
                            }
                         
                        }}
                    >
                        <ArrowBackIcon className={isWide?"home-button-wide":"home-button"}></ArrowBackIcon>
                    </IconButton>
                    
                    {newHudaList.current.length > 1 && (
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: isWide?"3rem":"2rem",
                                color: "rgb(228, 158, 74)",
                                position: "absolute",
                                left: "50%",
                                transform: "translate(-50%,0)",
                            }}
                        >
                            {newHudaList.current.length - currentIndex}/{newHudaList.current.length}
                        </span>
                    )}
                    {newHudaList.current.length > 1 && (
                        <IconButton
                            onClick={() => {
                                goBack();
                            }}
                        >
                            <UndoIcon className={isWide?"home-button-wide":"home-button"}></UndoIcon>
                        </IconButton>
                    )}
                </div>
                <div className="yomi-image kiwi-maru-light" style={{display:"flex",alignItems:"center", justifyContent:"center",height:"17vh" , fontSize:!isHeight?"1.2rem":""}}>
                 <p style={{ fontWeight: "500",margin:"0"}} className= {isSafari()?"isSafari":""}>
                            {setFurigana(newHudaList.current[currentIndex].yomi)}
                        </p>

                </div>
               
                <div className="play-image-advanced" style={{userSelect:"none"}}>
                    {newHudaList.current.map((element, index) => (
                        <div
                            style={{ display: "flex", justifyContent: "center" }}
                            key={index}
                        >
                            <TinderCard
                                ref={childRefs[index]}
                                className="swipe"
                                style={{ pointerEvents: "none", userSelect: "none" }}
                                onSwipe={(dir) => swiped(dir, index)}
                                onCardLeftScreen={() => outOfFrame(index)}
                                flickOnSwipe={true}
                                swipeThreshold={1}
                                swipeRequirementType="position"
                            >
                                <img
                                    src={element.eHuda}
                                    alt=""
                                    onLoad={(e) => {
                                        loadList.push(e);
                                    }}
                                    className="image-item-advance"
                                    style={{ pointerEvents: "none", userSelect: "none" }}
                                    loading={index >= newHudaList.current.length - 5 ? "eager" : "lazy"}
                                />
                            </TinderCard>
                        </div>
                    ))}

                </div>

                <div
                        style={{
                     display:"flex"
                        }}
                    >
                        <div style={{ margin: "auto auto 0 auto", display: "flex", flexDirection: "column" }}>
                            <Button
                                style={{ minWidth: isWide?"300px":"200px" }}
                                className="answer-button"
                                component="label"
                                variant="contained"
                                tabIndex={-1}
                                onClick={() => {
                                    play();
                                    setOpenBottomSheet(true);
                                }}
                                startIcon={<InsertCommentIcon style={{ fontSize: "1.5rem" }} />}
                            >
                                <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>解説をみる</span>
                            </Button>
                            <Button
                                style={{ marginTop: "1rem", minWidth: isWide?"300px":"200px" }}
                                className="answer-button"
                                component="label"
                                variant="contained"
                                tabIndex={-1}
                                onClick={() => {
                                    play();
                                    soundPlay();
                                }}
                                startIcon={<PlayCircleIcon style={{ fontSize: "1.5rem" }} />}
                            >
                                <span style={{ fontSize: "1.5rem", fontWeight: "500" }}>音声再生</span>
                            </Button>

                            {isPlaying && (
                                <div>
                                    <Lottie
                                        style={{ width: "5rem", height: "5rem", margin: "auto" }}
                                        animationData={soundAnimation}
                                    ></Lottie>
                                </div>
                            )}
                        </div>
                    </div>
            </div>

            <div>
                <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={handleClose}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", height: "100%" }}>
                        <div style={{ color: "white", fontSize: "3.5rem" }} className="kiwi-maru-medium">
                            スライドで
                            <br></br>
                            次の句へ
                        </div>
                        <Lottie style={{ width: "20rem", height: "20rem" }} animationData={animationData}></Lottie>
                    </div>
                </Backdrop>
            </div>
            <CustomAnswerSheet
                open={isOpenBottomSheet}
                setOpenBottomSheet={setOpenBottomSheet}
                yomiHuda={newHudaList.current[currentIndex].sdgsHuda}
            ></CustomAnswerSheet>
        </div>
    );
}

export default Advanced;
